import {
  Conditional,
  DealerLocatorFilterButton,
  DealerLocatorMapToggle,
  DealerLocatorOptions,
  useBreakpoint
} from '@cat-ecom/pcc-components';
import { DealerLocatorToggleButtons } from 'components/dealer-locator/dealer-location-toggle-buttons/DealerLocatorToggleButtons';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { useTranslations } from 'next-intl';

const DealerLocatorTogglesAndFilter = ({
  showOptions,
  isHidingMaps,
  isMapToggleChecked,
  handleMapToggle,
  isDealerLocatorLoading,
  isStoreLocationMapViewUpdateFlag,
  filtersDrawer,
  filtersCounter
}) => {
  const t = useTranslations();
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);

  return (
    <Conditional test={showOptions}>
      <DealerLocatorOptions data-testid="dealer-locator-options">
        <DealerLocatorToggleButtons>
          {!isHidingMaps && (
            <DealerLocatorMapToggle
              data-testid="dealer-locator-map-toggle"
              label={t('FYD_MAP_VIEW')}
              listViewLabel={t('SEGMENTED_LISTVIEW')}
              mapViewLabel={t('SEGMENTED_MAPVIEW')}
              isChecked={isMapToggleChecked}
              setIsChecked={handleMapToggle}
              isDisabled={isDealerLocatorLoading}
              isStoreLocationMapViewUpdateFlag={
                isStoreLocationMapViewUpdateFlag
              }
              isMobile={!isMD}
            />
          )}
        </DealerLocatorToggleButtons>

        <DealerLocatorFilterButton
          data-testid="dealer-locator-filter-button"
          filtersDrawer={filtersDrawer}
          filtersCounter={filtersCounter}
          isDisabled={isDealerLocatorLoading}
        >
          {t('ARIA_LANDMARK_FILTER')}
        </DealerLocatorFilterButton>
      </DealerLocatorOptions>
    </Conditional>
  );
};
export default DealerLocatorTogglesAndFilter;
